export const UPDATE_CC_DETAILS = 'mac/UPDATE_CC_DETAILS';
export const ENABLE_AUTO_RENEW = 'mac/ENABLE_AUTO_RENEW';
